var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.2C4.5 16.13 4.5 16.595 4.60222 16.9765C4.87962 18.0117 5.68827 18.8204 6.72354 19.0978C7.10504 19.2 7.57003 19.2 8.5 19.2H14.7C16.3802 19.2 17.2202 19.2 17.862 18.873C18.4265 18.5854 18.8854 18.1265 19.173 17.562C19.5 16.9202 19.5 16.0802 19.5 14.4V6.00001C19.5 4.31985 19.5 3.47978 19.173 2.83804C18.8854 2.27355 18.4265 1.81461 17.862 1.52699C17.2202 1.20001 16.3802 1.20001 14.7 1.20001H8.5C7.57003 1.20001 7.10504 1.20001 6.72354 1.30223C5.68827 1.57964 4.87962 2.38828 4.60222 3.42356C4.5 3.80506 4.5 4.27004 4.5 5.20001M10.5 6.20001L14.5 10.2M14.5 10.2L10.5 14.2M14.5 10.2H1.5",
    stroke: "url(#paint0_linear_705_2124)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_705_2124",
    x1: 10.5,
    y1: 1.20001,
    x2: 10.5,
    y2: 19.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2467C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03AC53"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.28a1b59549d1b7fc907fc6d8f2656ac1.svg";
export { ForwardRef as ReactComponent };